import type { FC } from "react";

import { TransitionLinkV2 } from "@/src/common/TransitionLinkV2";
import { urlFormat } from "@Components/Modules/Helpers";
import type { BlogPostMobile } from "@Routes/BlogLinks";
import * as stylex from "@stylexjs/stylex";

export interface IArticle {
    title: string;
    id: number;
    slug: string;
}

export interface IPopularArticles {
    data: IArticle[];
    urlTemplate: typeof BlogPostMobile;
}

const PopularArticles: FC<IPopularArticles> = ({ data, urlTemplate }) => {
    if (!data) {
        return null;
    }

    return (
        <div {...stylex.props(styles.popularArticles)}>
            <h3 {...stylex.props(styles.title)}>Polecane artykuły</h3>
            {data.map(({ title, id, slug }) => (
                <TransitionLinkV2 key={id} href={urlFormat(urlTemplate, { id, slug })} styleX={styles.link}>
                    <h4 {...stylex.props(styles.article)} dangerouslySetInnerHTML={{ __html: title }} />
                </TransitionLinkV2>
            ))}
        </div>
    );
};

export { PopularArticles };

const styles = stylex.create({
    popularArticles: {
        borderColor: "#e4e4e4",
        borderStyle: "solid",

        borderWidth: "1px",
        backgroundColor: "white",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
    },

    title: {
        margin: 0,
        paddingBlock: "20px",
        paddingInline: "15px",
        fontSize: "1rem",
        textTransform: "uppercase",
    },

    link: {
        borderRadius: 0,

        paddingBlock: 0,
        paddingInline: 0,
        transition: "background-color 300ms ease",
        backgroundColor: {
            default: "rgba(0, 0, 0, 0.08)",
            ":hover": "rgba(0, 0, 0, 0.04)",
        },
        display: "block",
        textAlign: "left",
    },
    article: {
        margin: 0,
        padding: "0.5rem",
        color: "black",
        fontSize: "0.875rem",
        fontWeight: 300,
        textTransform: "none",
    },
});
